import type { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/chemistry/elements/components/stack/x-stack.js';
import { stateful } from '@adornis/functional-lit/stateful';
import { html } from 'lit';
import type { Draft } from '../db/Draft';
import { CreateDraft } from './CreateDraft';
import { ReviewDraftsList } from './ReviewDraftsList';

export const DraftsByReference = stateful(
  ({
    draftClassName,
    reference,
    getEditDraftPath,
    draftTemplate,
  }: {
    draftClassName: string;
    reference: MongoEntity;
    getEditDraftPath: (draft: Draft) => string;
    draftTemplate?: Draft;
  }) => {
    return html`
      <d-flex space="md">
        <d-h2 ${css({ fontSize: '24px' })}>Entwürfe</d-h2>
        ${CreateDraft({
          draftClassName,
          reference: {
            _class: reference._class,
            _id: reference._id,
          },
          onAfterCreateCallback: draft => {},
          draftTemplate,
        })}
        ${ReviewDraftsList.render({
          draftClassName,
          referenceID: reference._id,
          getCommentDraftPath: getEditDraftPath,
        })}
      </d-flex>
    `;
  },
);
